import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String, copied: String, failed: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
    } catch {
      window.prompt(this.failedValue, this.urlValue)
      return
    }
    window.alert(this.copiedValue)
  }
}
